/* Creazione di un percorso dalle coordinate e dall'address from e address to inserite neli' url */

import { useEffect } from "react";
import { connect } from 'react-redux'
import {fetchPath,changepositionStart, changepositionEnd,selectNewMarkerStart,selectNewMarkerEnd, selectNewMarkerStart2, selectNewMarkerEnd2, changeNomeFermataEnd,changeNomeFermataStart,changePositionTariffaStart,changePositionTariffaEnd} from '../../redux'

function FirstPath(props){
  const {search,changepositionStart,changepositionEnd,markerStart,markerEnd,markerStart2,markerEnd2,fetchPath,data,changeNomeFermataStart,changeNomeFermataEnd,changePositionTariffaStart,changePositionTariffaEnd} = props
  
  
    useEffect(()=>{
      try {
        //Importazione package qs
        var qs = require('qs');
        
        var fromPlace = qs.parse(search, { ignoreQueryPrefix: true }).fromPlace
        var toPlace = qs.parse(search, { ignoreQueryPrefix: true }).toPlace
        var addressFrom = qs.parse(search, { ignoreQueryPrefix: true }).address_from
        var addressTo = qs.parse(search, { ignoreQueryPrefix: true }).address_to

        var pointFrom = null
        var pointTo = null
        if (fromPlace && fromPlace !== "" && (!addressFrom || addressFrom === "")) addressFrom = `${fromPlace}`
        if (toPlace && toPlace !== "" && (!addressTo || addressTo === "")) addressTo = `${toPlace}`
        if (fromPlace && fromPlace !== "" && addressFrom && addressFrom !== "" ) pointFrom = { description: `${addressFrom}`, lat: `${fromPlace.split(",")[0]}`, lng: `${fromPlace.split(",")[1]}` }
        if (toPlace && toPlace !== "" && addressTo && addressTo !== "") pointTo = { description: `${addressTo}`, lat: `${toPlace.split(",")[0]}`, lng: `${toPlace.split(",")[1]}` }
      
      if (pointFrom && pointTo){
        //let pointFrom = { description: `${addressFrom}`, lat: `${fromPlace.split(",")[0]}`, lng: `${fromPlace.split(",")[1]}` }
        //let pointTo = { description: `${addressTo}`, lat: `${toPlace.split(",")[0]}`, lng: `${toPlace.split(",")[1]}` }
        changeNomeFermataStart(pointFrom.description)
        changeNomeFermataEnd(pointTo.description)
        //changepositionStart(fromPlace)
        //changepositionEnd(toPlace)
        changepositionStart(pointFrom)
        changepositionEnd(pointTo)
        //changePositionTariffaStart([{ description: `${addressFrom}`, lat: `${fromPlace.split(",")[0]}`, lng: `${fromPlace.split(",")[1]}` }])
        //changePositionTariffaEnd([{ description: `${addressTo}`, lat: `${toPlace.split(",")[0]}`, lng: `${toPlace.split(",")[1]}` }]) 
        changePositionTariffaStart(pointFrom)
        changePositionTariffaEnd(pointTo)
        markerStart2(pointFrom)
        markerEnd2(pointTo)
      } else if (pointFrom && !pointTo){
        //const split = fromPlace.split(',')
        //let pointFrom = { description: `${addressFrom}`, lat: `${fromPlace.split(",")[0]}`, lng: `${fromPlace.split(",")[1]}` }
        changepositionStart(pointFrom)
        changeNomeFermataStart(pointFrom.description)
        changePositionTariffaStart(pointFrom)
        markerStart(pointFrom)
        //markerStart({lat:split[0],lng:split[1]})
      } else if (!pointFrom && pointTo) {
        //const split = toPlace.split(',')
        //let pointTo = { description: `${addressTo}`, lat: `${toPlace.split(",")[0]}`, lng: `${toPlace.split(",")[1]}` }
        changepositionEnd(pointTo)
        changeNomeFermataEnd(pointTo.description)
        changePositionTariffaEnd(pointTo) 
        markerEnd(pointTo)
      }

      if (pointFrom && pointTo){
        const date = new Date();
        const time = `${date.getHours()}%3A${date.getMinutes()}`
        const dateAssoluta = `${date.getMonth()+1}-${date.getDate()}-${date.getFullYear()}`

        //AGGIUNTO
        var mode = 'BUS%2CRAIL%2CTRAM%2CFERRY%2CWALK'
        if(isInSardegna(pointFrom.lat,pointFrom.lng) !== isInSardegna(pointTo.lat,pointTo.lng)) mode = 'TRANSIT%2CWALK'
        
        const url = `${data.httpProxy.urlOTP}/plan?fromPlace=${fromPlace}&toPlace=${toPlace}&time=${time}&date=${dateAssoluta}&mode=${mode}&arriveBy=false&maxWalkDistance=804.672&wheelchair=falsese&locale=it`
        if (fromPlace !== "" && toPlace!== "" ){
          const url2 = {url:url,ordine:4}
          fetchPath(url2)
        }
      }
    } catch (error) {
      console.log(error.error)
    }
  },[search])
      return null

}

function isInSardegna(lat,lng){
  const minLat = 38.741138
  const maxLat = 41.354026
  const minLng = 7.918701
  const maxLng = 9.907226
  if(lat < maxLat && lat > minLat && lng < maxLng && lng > minLng) return true
  else return false;
}


const mapStateToProps = state => {
    return {
        pathData: state.path,
        positionStart: state.positionStart,
        markerStart: state.markerStart,
        markerEnd: state.markerEnd,
        markerStart2: state.markerStart2,
        markerEnd2: state.markerEnd2,
        nomeFermataStart: state.nomeFermataStart,
        nomeFermataEnd:state.nomeFermataEnd,
        positionTariffaStart:state.positionTariffaStart,
        positionTariffaEnd:state.positionTariffaEnd
  
    }
  }
  
  const mapDispatchToProps = dispatch => {
    return {
        fetchPath: (url) => dispatch(fetchPath(url)),
        changepositionStart: (positionStart) => dispatch(changepositionStart(positionStart)),
        changepositionEnd: (positionEnd) => dispatch(changepositionEnd(positionEnd)),
        markerStart: (marker) => dispatch(selectNewMarkerStart(marker)),
        markerEnd: (marker) => dispatch(selectNewMarkerEnd(marker)),
        markerStart2: (marker) => dispatch(selectNewMarkerStart2(marker)),
        markerEnd2: (marker) => dispatch(selectNewMarkerEnd2(marker)),
        changeNomeFermataStart: (nomeFermataStart) => dispatch(changeNomeFermataStart(nomeFermataStart)),
        changeNomeFermataEnd: (nomeFermataEnd) => dispatch(changeNomeFermataEnd(nomeFermataEnd)),
        changePositionTariffaStart:(positionTariffaStart) => dispatch(changePositionTariffaStart(positionTariffaStart)),
        changePositionTariffaEnd:(positionTariffaEnd) => dispatch(changePositionTariffaEnd(positionTariffaEnd))
    }
  }
  export default connect(mapStateToProps,mapDispatchToProps) (FirstPath);